import React, {FunctionComponent} from "react";
import './RegularCustomer.less';
import {Button} from "../../elements/button/Button";
import {getSafeTranslation} from "../../../helpers/localization.helper";

interface RegularCustomerProps {
    onLogin: () => void;
    onRegister: () => void;
    translations: any;
}
export const RegularCustomer:FunctionComponent<RegularCustomerProps> = ({onLogin, onRegister, translations}) => {
    return (
        <div className="regular-customer-wrap">
            <div className="regular-customer">
                <div className="regular-customer__info">
                    <div className="regular-customer__info-title">
                        {getSafeTranslation('RegularCustomer.areYouARegularCustomer', translations)}
                    </div>
                    <div className="regular-customer__info-description">
                        {getSafeTranslation('RegularCustomer.getExtraPerks', translations)}
                    </div>
                </div>
                <div className="regular-customer__actions">
                    <Button onClick={onLogin} isAutoWidth={true}>Login</Button>
                    <Button onClick={onRegister} isAutoWidth={true}>Register</Button>
                </div>
            </div>
        </div>
    )
}
